module.exports = __webpack_public_path__ + "img/07_uk.322f7b89.svg";